export const BACKEND_URL = "https://us-central1-vr-pilot-9aebf.cloudfunctions.net/api";
// export const BACKEND_URL = "http://localhost:5004";
